import type { SavedForwardAccumulator } from '@/domain/WorkspaceForex/savedProducts/forwardAccumulator/SavedForwardAccumulator.ts';
import type { FxForwardAccumulator } from '@/store/forwardAccumulator/state.ts';
import { generateEmptyForwardAccumulator } from '@/store/forwardAccumulator/utils.ts';

export function mapToForwardAccumulator({ properties, clientId }: SavedForwardAccumulator): FxForwardAccumulator {
  return generateEmptyForwardAccumulator(
    {
      currencyPair: properties.currencyPair,
      notional: properties.notional ?? null,
      notionalCurrencyIndex: properties.notionalCurrencyIndex,
      premiumDate: properties.premiumDate,
      cutOffMarketPlace: properties.cutOffMarketPlace,
      deliveryDate: properties.deliveryDate,
      expiryDate: properties.expiryDate,
      marginCurrency: properties.marginCurrency,
      amountMode: properties.amountMode,
      clientsWay: properties.clientsWay ?? 'Buy',
      leverage: properties.leverage,
      leverageAmount: properties.leverageAmount,
      strike: properties.strike,
      ekiTrigger: properties.ekiTrigger,
      akoTrigger: properties.akoTrigger,
      firstFixingDate: properties.firstFixingDate,
      lastFixingDate: properties.lastFixingDate,
      numberOfFixings: properties.numberOfFixings,
      numberOfSettlements: properties.numberOfSettlements,
      markupCurrency: properties.markupCurrency,
      fixingFrequency: properties.fixingFrequency,
      settlementFrequency: properties.settlementFrequency,
      isCrossed: properties.isCrossed,
      crossCurrency: properties.crossCurrency,
      maxDate: properties.maxDate,
      step: properties.step,
    },
    clientId,
  );
}
